import { useCallback } from "react";
import { useRADStoreContext } from "../../RADStoreContext.js";
import { createRAD } from "@cadenza/rad-domain";
import { nanoid } from "nanoid";

export const useRADActions = () => {
  const { getRADs, updateRADs } = useRADStoreContext();

  const setupRAD = ({ process_id, label }) =>
    createRAD({ name: label, principal_process_id: process_id });

  const getRAD = useCallback(
    (id) => getRADs().find((rad) => rad.id === id),
    [getRADs]
  );

  const getRADsArray = useCallback(() => getRADs(), [getRADs]);

  const getCleanRADs = useCallback(
    () => getRADs().filter((rad) => rad.info),
    [getRADs]
  );

  const update = useCallback(
    (updater) => {
      const current = getRADs();
      const updated = updater(current);
      updateRADs(updated);
    },
    [getRADs, updateRADs]
  );

  const handleNewRAD = useCallback(
    ({ onNavigate } = {}) => {
      const newId = nanoid();
      const newRAD = createRAD({
        id: newId,
      });

      update((rads) => [...rads, newRAD]);

      if (onNavigate) onNavigate(`/rad/${newId}`);
    },
    [update]
  );

  const handleUpdateRAD = useCallback(
    (rad) => {
      if (!rad?.id) return;
      console.log("Updating RAD:", rad);
      update((rads) => rads.map((r) => (r.id === rad.id ? rad : r)));
    },
    [update]
  );

  const handleDeleteRAD = useCallback(
    (id) => {
      update((rads) => rads.filter((rad) => rad.id !== id));
    },
    [update]
  );

  const handleDeleteAllRADs = useCallback(() => {
    update(() => []);
  }, [update]);

  return {
    setupRAD,
    handleNewRAD,
    handleUpdateRAD,
    handleDeleteRAD,
    handleDeleteAllRADs,
    getRAD,
    getRADs: getRADsArray,
    getCleanRADs,
  };
};
